import {
    FETCH_TASKS,
    FETCH_TASKS_SUCCESS,
    FETCH_TASKS_FAILED,
    ACCEPT_TASK,
    CANCEL_TASK,
} from "../store/types";

const INITIAL_STATE = {
    tasks: null,
    loading: false,
    error: {
        flag: false,
        msg: null
    }
}

export const tasklistreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_TASKS:
            return {
                ...state,
                loading: true,
                error: {
                    flag: false,
                    msg: null
                }
            };
        case FETCH_TASKS_SUCCESS:
            return {
                ...state,
                tasks: action.payload,
                loading: false,
                error: {
                    flag: false,
                    msg: null
                }
            };
        case FETCH_TASKS_FAILED:
            // Listener-error path: preserve previous tasks so the UI does not
            // blank out while the resubscribe retry is pending.
            return {
                ...state,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                }
            };
        case ACCEPT_TASK:
            return {
                ...state
            }; 
        case CANCEL_TASK:
            return {
                ...state
            };
        default:
            return state;
    }
};